import { Injectable } from '@angular/core';
import { ApiHttpClient, ListOption, Deferred } from '../modules/tcm-core.module';
import { AutocompleteAddressDetailsViewModel } from '../models/addresses';
import { GoogleMapsLoaderService } from './google-maps-loader.service';

@Injectable({
  providedIn: 'root'
})
export class GeocodingDataService {
  constructor(
    private readonly httpClient: ApiHttpClient,
    private readonly googleMapsLoader: GoogleMapsLoaderService
  ) {
  }

  public getAddressOptionsAsync(query: any, searchInAllCountries: boolean, cancellationToken: Promise<any>): Promise<ListOption<string>[]> {
    const request = { address: query, searchInAllCountries: searchInAllCountries };
    return this.httpClient.getJsonAsync<ListOption<string>[]>("address/AutocompleteAddress", request, cancellationToken);
  }

  public getAddressDetailsAsync(placeId: any, cancellationToken: Promise<any>): Promise<AutocompleteAddressDetailsViewModel> {
    return this.httpClient.getJsonAsync<AutocompleteAddressDetailsViewModel>("address/GetAddressDetails", { placeId }, cancellationToken);
  }

  public async getAddressLocationAsync(address: string): Promise<google.maps.LatLng> {
    // Ensure Google Maps is loaded before using it
    await this.googleMapsLoader.load();
    
    const deferred = new Deferred();
    const geocoder = new google.maps.Geocoder();

    geocoder.geocode({ address: address },
      (results, status) => {
        if (status == google.maps.GeocoderStatus.OK) {
          if (results && results.length && results[0] && results[0].geometry && results[0].geometry.location) {
            const location = { lat: results[0].geometry.location.lat(), lng: results[0].geometry.location.lng() };
            deferred.resolve(location);
          }
          else {
            deferred.reject();
          }
        }
        else {
          deferred.reject();
        }
      });

    return deferred.promise();
  }
}
